<template>
  <div class="product-group">
    <div class="container fr-aic fr-jcsb">
      <comp-tab :data="[{ label: '已使用', value: 1 }, { label: '未使用', value: 2 }]" v-model="params.isused" />
    </div>

    <div class="container">
      <el-row gutter="8">
        <el-col span="4">
          <el-input placeholder="输入用户手机号" prefix-icon="el-icon-search" size="small" v-model="params.usermobile"></el-input>
        </el-col>
        <el-col span="4">
          <el-button @click="onSearch" size="small">搜索</el-button>
        </el-col>
        <el-col class="fr-jcfe" offset="12" span="4">
          <el-button @click="showDialog = true" size="small" type="primary">发放优惠券</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="container" id="table">
      <el-table :data="list" border ref="table" style="width: 100%">
        <el-table-column align="center" label="ID" prop="id" width="50px" />
        <el-table-column label="名称" prop="name" />
        <el-table-column label="用户">
          <template slot-scope="{ row }">
            {{ row.user.nickname }}({{ row.user.mobile }})
          </template>
        </el-table-column>
        <el-table-column label="面值">
          <template slot-scope="{ row }">
            {{ row.amount / 100 }}元
          </template>
        </el-table-column>
        <el-table-column label="使用条件">
          <template slot-scope="{ row }">
            满{{ row.reach / 100 }}元可用
          </template>
        </el-table-column>
        <el-table-column label="有效期">
          <template slot-scope="{ row }">
            <div v-if="row.timebegin == 0 && row.timeend == 0">不限制</div>
            <div v-if="row.timebegin > 0 || row.timeend > 0">{{ new Date(row.timebegin * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }} - {{ new Date(row.timeend * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template slot-scope="{ row }">
            <el-button @click="$router.push({ name: 'marketing-coupon-detail', query: { id: row.id } })" size="small" type="text">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-bottom">
        <el-button v-if="hasMore" :loading="loadmore" @click="getCoupons" size="small" type="primary">加载更多</el-button>
        <span style="color: #ccc; font-size: 12px;" v-else>已经加载完成，没有更多了</span>
      </div>
    </div>

    <!--  编辑分类弹框 -->
    <el-dialog :visible.sync="showDialog" title="发放优惠券" width="400px">
      <el-form :model="form" label-width="100px" ref="form" size="small">
        <el-form-item label="优惠券模版">
          <el-col span="16">
            <el-autocomplete value-key="label" v-model="form.coupontemplateid" :fetch-suggestions="querySearchAsync" @select="selectHand" placeholder="请输入优惠券模版名称"></el-autocomplete>
          </el-col>
        </el-form-item>
        <el-form-item label="用户手机号">
          <el-col span="16">
            <el-input placeholder="输入用户手机号" v-model="form.usermobile"></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div class="dialog-footer fr-jcfe" slot="footer">
        <el-button @click="onSubmit" size="small" type="primary">发放</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Tab from '../../../components/tab/index.vue';
import { M } from '../../../service/grpc.js';
import { rpc, rpc1 } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';

export default {
  components: {
    'comp-tab': Tab
  },
  data() {
    return {
      list: [],
      params: {
        isused: 1,
        userid: 0,
        idlessthan: 0,
        count: 20,

        usermobile: ''
      },
      form: {
        userid: 0,
        coupontemplateid: '',

        usermobile: ''
      },
      loadmore: false,
      hasMore: true,
      showDialog: false,
      token: ''
    };
  },
  watch: {
    'params.isused': function() {
      this.list = [];
      this.getCoupons();
    }
  },
  created() {
    this.token = getToken();
    this.getCoupons();
  },
  methods: {
    async getCoupons() {
      this.loadmore = true;
      const { scrollY } = window;
      this.params.idlessthan = this.list.length ? this.list[this.list.length - 1].id : 0;

      this.params.userid = 0;
      // 根据手机号获取用户id
      if (this.params.usermobile) {
        const res = await rpc(
          'StoreUserService.GetUserList',
          M('UserListQueryRequest', {
            token: M('Token', { token: this.token }),
            mobile: this.params.usermobile,
            count: 1,
            order: 0
          })
        );
        if (!res.userlistList.length) {
          this.hasMore = 0;
          this.loadmore = false;
          return;
        }
        this.params.userid = res.userlistList[0].id;
      }
      const res = await rpc(
        'StoreCouponService.GetCouponList',
        M('CouponListQueryRequest', {
          token: M('Token', { token: this.token }),
          ...this.params
        })
      );
      const useridlist = res.couponlistList.map(v => v.userid);
      const res1 = await rpc(
        'StoreUserService.GetUserList',
        M('UserListQueryRequest', {
          token: M('Token', { token: this.token }),
          idlistList: useridlist,
          count: useridlist.length,
          order: 0
        })
      );
      res.couponlistList.forEach(item => (item.user = res1.userlistList.find(v => v.id == item.userid)));
      this.list = this.list.concat(res.couponlistList);
      this.hasMore = res.couponlistList.length;
      if (this.params.idlessthan !== 0) {
        window.scroll(0, scrollY);
      }
      this.loadmore = false;
    },

    querySearchAsync(queryString, cb) {
      rpc1(
        'StoreCouponTemplateService.GetCouponTemplateList',
        M('CouponTemplateListQueryRequest', {
          token: M('Token', { token: this.token }),
          isdeleted: 2,
          count: 100,
          name: queryString
        })
      ).then(res => {
        cb(
          res.coupontemplatelistList.map(item => ({
            value: item.id,
            label: item.name
          }))
        );
      });
    },

    async onSubmit() {
      const res = await rpc1(
        'StoreUserService.GetUserList',
        M('UserListQueryRequest', {
          token: M('Token', { token: this.token }),
          mobile: this.form.usermobile,
          count: 1,
          order: 0
        })
      );
      this.form.userid = res.userlistList.length ? res.userlistList[0].id : 0;
      const user = res.userlistList.length ? res.userlistList[0] : null;

      this.showDialog = false;
      this.$confirm('确认要发放给该用户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          rpc(
            'StoreCouponService.CreateCoupon',
            M('StoreCreateCouponRequest', {
              token: M('Token', { token: this.token }),
              ...this.form
            })
          ).then(res => {
            if (this.params.isused == 2) {
              res.user = user;
              this.list.splice(0, 0, res);
            }
            this.$message({ message: '发放成功', type: 'success' });
            this.showDialog = false;
            this.form = {
              userid: 0,
              coupontemplateid: '',

              usermobile: ''
            };
          });
        })
        .catch(() => {
          this.showDialog = true;
        });
    },

    selectHand(e) {
      this.form.coupontemplateid = e.value;
    },

    onSearch() {
      this.list = [];
      this.getCoupons();
    }
  }
};
</script>

<style>
.product-group .el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 90px;
}

.product-group .category-wrapp {
  display: flex;
  align-items: center;
}

.product-group .el-upload.el-upload--picture-card {
  margin-bottom: 0 !important;
}

.product-group .el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
  margin: 0;
}

.product-group .el-upload-list__item.is-success .el-upload-list__item-status-label {
  opacity: 0;
}

.product-group .upload-img {
  width: 80px;
  height: 80px;
  position: relative;
}

.product-group .upload-img img {
  width: 80px;
  height: 80px;
}

.product-group .upload-img:hover .upload-img_button {
  display: block;
}

.product-group .upload-img_button {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 80px;
  height: 80px;
  background-color: rgba(0, 0, 0, 0.4);
  text-align: center;
  line-height: 80px;
  color: #fff;
  cursor: pointer;
}
</style>
